import classNames from "classnames";
import React from "react";

type CaTableRowProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLTableRowElement>,
  HTMLTableRowElement
>;

function CaTableRow({ className, ...props }: CaTableRowProps) {
  return (
    <tr
      className={classNames("border-b border-light-neutral-2 hover:bg-light-neutral-4", className)}
      {...props}
      contentEditable={undefined}
    />
  );
}

export default CaTableRow;
